// Formats HollowScript through the native runtime's own `format()`
// (`crates/hollowscript-wasm/src/tooling.rs`), so the editor's "Format
// Document" action matches the same canonical layout the native CLI's own
// `hollowscript format` produces and the language repo's own corpus is
// written in - the same guarantee the previous `@hollow/script`-backed
// version of this file aimed for by porting Cascade's formatter, now met
// by the reference implementation directly instead of a second one kept in
// sync with it. See `nativeScriptRunner.ts`'s top doc comment for why this
// moved only once diagnostics did (loading the tooling wasm a second time,
// in the main thread, only became "free" once diagnostics already paid
// that cost).

import { getMonacoTooling, type MonacoTooling } from '../nativeTooling.js';

export interface HollowScriptFormatResult {
  readonly formatted?: string;
  readonly error?: string;
}

/** Formats `source`, or explains why it could not be (a parse error - the
 * formatter never guesses at malformed input, spec.md's own rule). Never
 * throws. */
export async function formatHollowScriptSource(
  source: string,
  /** Only tests pass this, to avoid loading the real wasm in a unit test. */
  tooling?: Pick<MonacoTooling, 'format'>,
): Promise<HollowScriptFormatResult> {
  const t = tooling ?? (await getMonacoTooling());
  const result = t.format(source);
  if (result.output !== null) return { formatted: result.output.join('\n') };
  const message = result.diagnostics.map((d) => d.message).join('; ') || 'Could not format: the source has a parse error.';
  return { error: message };
}
